




















import Component from "vue-class-component";
import NumberInput from "@/components/common/NumberInput.vue";
import OneService from "@/components/medicalEdit/specification/part/OneService.vue";

@Component({
  components: {
    NumberInput
  }
})
export default class SchoolService extends OneService {}
